import React, { useState } from "react";
import { ControllableInput } from "./Input";
import { TextFieldInputProps } from "@carrier-io/air-react/TextField";
import IconButton from "@carrier-io/air-react/IconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { PasswordInput as PasswordInputType } from "../../validations/password";

export const ControllablePasswordInput = (
  props: React.ComponentProps<typeof ControllableInput<PasswordInputType>>,
) => {
  const [showPassword, setShowPassword] = useState(true);

  const changePasswordVisible = () => {
    setShowPassword((prevValue) => !prevValue);
  };

  const input: TextFieldInputProps = {
    endAdornment: (
      <IconButton size="small" onClick={changePasswordVisible}>
        {showPassword ? (
          <VisibilityOutlinedIcon fontSize="small" sx={{ width: "20px" }} />
        ) : (
          <VisibilityOffOutlinedIcon fontSize="small" sx={{ width: "20px" }} />
        )}
      </IconButton>
    ),
    type: showPassword ? "password" : "text",
  };

  return <ControllableInput<PasswordInputType> {...props} InputProps={input} />;
};
